import { render, staticRenderFns } from "./BrowseTrWorkFile.vue?vue&type=template&id=5f2c22bf&"
import script from "./BrowseTrWorkFile.vue?vue&type=script&lang=js&"
export * from "./BrowseTrWorkFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports